// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.my-wrap .content[data-v-45a73b82] {\n  background-color: var(--bg-primary) !important;\n  border: none !important;\n  padding: 40px !important;\n}\n.popup-success button.button-style-5[data-v-45a73b82] {\n  margin-left: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
